import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Logger } from '../logger.service';
import { AuthenticationService } from './authentication.service';
import { KeycloakService, KeycloakAuthGuard } from 'keycloak-angular';

@Injectable()
export class AuthenticationGuard {
  constructor(
    private router: Router,
    private authService: AuthenticationService
  ) {}

  canActivate() {
    if (this.authService.isAuthenticated()) {
      return true;
    }
    this.router.navigate(['login']);
    return false;
  }

  canActivateChild() {
    if (this.authService.isAuthenticated()) {
      return true;
    }
    this.router.navigate(['login']);
    return false;
  }
}

// Extend with KeycloakAuthGuard
// Auto Refresh Token feature not working...
// For now we are implementing in AuthenticationService using TokenExpired Event...

// @Injectable()
// export class AuthenticationGuard extends KeycloakAuthGuard implements CanActivateChild {
//   constructor(protected router: Router, private authService: AuthenticationService, protected readonly keycloak: KeycloakService
//     ) {
//     super(router, keycloak);
//   }

//   async canActivateChild(

//   ) {

//     if (!(await this.keycloak.isLoggedIn())) {
//       await this.keycloak.login({
//       });
//     }

//     return true;
//   }

//   async isAccessAllowed(
//     route: ActivatedRouteSnapshot,
//     state: RouterStateSnapshot): Promise<boolean | UrlTree> {

//     if (!this.authenticated) {
//       await this.keycloak.login({
//         redirectUri: window.location.origin + state.url,
//       });
//     }

//     return this.authenticated;
//   }
// }
